import React, { FC, Fragment } from "react";
import { useStyles } from "../../useStyles";
import { useFormModel } from "../core/FormModelHelpes";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { NumberInput } from "../core/NumberField";
import { InputLabel } from "@material-ui/core";

export const NewConnectionMultilineBasePlateHeightForm: FC = () => {
    const classes = useStyles();

    const { values, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_BASE_PLATE_HEIGHT
    >();

    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                Bodenplatte
            </h4>
            <p className={classes.p} style={{ marginBottom: 0, marginTop: 16 }}>
                Geben Sie das Gesamtmaß Oberkante Rohfußboden bis Oberkante Fertigfußboden an. Das
                Gesamtmaß beinhaltet folgende Ebenen der Bodenplatte: Dämmung, Estrich, Fließen,
                sonstige Aufbauten
            </p>
            <InputLabel
                className={
                    values.newConnectionMultilineBasePlateHeight.error
                        ? classes.labledTextfieldLabelError
                        : classes.labledTextfieldLabel
                }
                style={{ marginTop: 24 }}
            >
                Gesamtmaß Bodenplatte *
            </InputLabel>
            <NumberInput
                className={classes.textField}
                fixedDecimalScale={false}
                allowLeadingZeros={false}
                decimalScale={values.newConnectionMultilineBasePlateHeight.value.precision}
                isNumericString={false}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                adornment={values.newConnectionMultilineBasePlateHeight.value.unit}
                value={values.newConnectionMultilineBasePlateHeight.value.amount.num || ""}
                placeholder="0"
                onValueChange={v =>
                    setValues(values => {
                        values.newConnectionMultilineBasePlateHeight.value.amount.num =
                            v.floatValue || 0;
                    })
                }
                error={values.newConnectionMultilineBasePlateHeight.error !== null}
            />
        </Fragment>
    );
};
